import { render } from "./CoverImage.vue?vue&type=template&id=504fb2a3"
import script from "./CoverImage.vue?vue&type=script&lang=js"
export * from "./CoverImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__